export default __webpack_public_path__ + "static/media/imbuedweb.5ad59292.mp4";